module.exports = __webpack_public_path__ + "static/media/Plateau_L_3.403d3725.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/Plateau_L_3.svg
// module id = 788
// module chunks = 0